export default {"src":"/_next/static/media/auth8.db1410a4.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};